import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/lus/";

const LusApi = {
	getLus(lusId) {
		const listByUrl = prependRoot(routePrefix + "get/" + lusId, getApiRoot());
		return axios.get(listByUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	saveLus(model, documents) {
		const serviceUrl = prependRoot(routePrefix + 'save', getApiRoot());
		return axios.put(serviceUrl, {
			item: model,
			documenten: documents,
		},
			{
				headers: {
					'accept': 'application/json'
				}
			}
		);
	},
	loadSimplifiedWktForGpx(gpx) {
		const url = prependRoot(routePrefix + "loadSimplifiedWktForGpx/", getApiRoot());
		return axios.post(url,
			gpx,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	getWerkelijkeLusAfstand(gpx) {
		const url = prependRoot(routePrefix + "getWerkelijkeLusAfstand/", getApiRoot());
		return axios.post(url,
			gpx,
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default LusApi;
